<template>
  <div class="enterOrder">
    <div v-if="order_id && ifFinish" class="enterOrder-content noTab">
      <a-tabs :defaultActiveKey="client_data_type" class="orderForm-tabs">
        <a-tab-pane class="orderForm-pane" tab="渠道方代注册" key="1">
          <a-alert class="banner-tip" message="注册小程序，请电脑访问微信公众平台：http://mp.weixin.qq.com" banner/>
          <channelForm :complete="true" :order_id="order_id"/>
        </a-tab-pane>
        <a-tab-pane class="orderForm-pane" tab="厂商代注册" key="2">
          <manufacturerForm :complete="true" :order_id="order_id"/>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div v-else-if="order_id" class="enterOrder-content">
      <a-tabs :defaultActiveKey="client_data_type" class="orderForm-tabs">
        <a-tab-pane class="orderForm-pane" tab="渠道方代注册" key="1">
          <a-alert class="banner-tip" message="注册小程序，请电脑访问微信公众平台：http://mp.weixin.qq.com" banner/>
          <channelForm :order_id="order_id"/>
        </a-tab-pane>
        <a-tab-pane class="orderForm-pane" tab="厂商代注册" key="2">
          <manufacturerForm :order_id="order_id"/>
        </a-tab-pane>
      </a-tabs>
    </div>

    <div v-else class="enterOrder-content">
      <a-tabs defaultActiveKey="1" class="orderForm-tabs">
        <a-tab-pane class="orderForm-pane" tab="录入订单" key="1">
          <enterOrderForm :ifSubmit="true"/>
        </a-tab-pane>
        <a-tab-pane class="orderForm-pane" tab="体验录入" key="2">
          <a-alert
            class="banner-tip"
            message="当前您选择的是【体验录单】流程，并非真实录单，如需真实录单请选择【录入订单】。【体验录入】仅供学习与测试工单的使用流程。"
            banner
          />
          <tryForm/>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import tryForm from "../enterForms/tryForm";
import enterOrderForm from "../enterForms/orderForm";
import channelForm from "../enterForms/channelForm";
import manufacturerForm from "../enterForms/manufacturerForm";
export default {
  name: "enterOrder",
  components: {
    enterOrderForm,
    channelForm,
    manufacturerForm,
    tryForm
  },
  props: ["order_id", "client_data_type", "ifFinish"],
  data() {
    return {};
  },
  created() {}
};
</script>
<style scoped>
.enterOrder {
  min-height: calc(100vh - 66px);
}
.enterOrder-content {
  width: 1461px;
  margin: 0 auto;
  padding-top: 18px;
}
.enterOrder-content >>> .ant-tabs-bar {
  border-bottom: none;
}
.enterOrder-content.noTab >>> .ant-tabs-bar {
  visibility: hidden;
}
.enterOrder-content .orderForm-tabs {
  min-height: calc(100vh - 132px);
  padding-bottom: 40px;
}
.enterOrder-content .orderForm-pane {
  background: #fff;
  padding-top: 40px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.banner-tip {
  margin-bottom: 30px;
  min-width: 800px;
  text-align: center;
}
.banner-tip>>>.ant-alert-icon{
  position:static;
  margin-right: 10px;
}

</style>
